import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { ORDER_TYPE } from '@/constants/order_type'
import { QUERIES } from '@/constants/queries'
import { REQUEST_STATUS } from '@/constants/request-status'
import { REQUEST_TYPE } from '@/constants/request-type'
import { getRequests } from '@/services/requests/get-requests'
import type { Request } from '@/types/requests/request'
import type { TableData } from '@/types/table/table-data'
import { basicDataCellFormatter } from '@/utils/basic-data-cell-formatter'
import { createTableConfig } from '@/utils/create-table-config'
import { getDeadlineColorByName } from '@/utils/get-deadline-color-by-id'
import { getUrlRedirectByRequest } from '@/utils/get-url-redirect-by-request'

function createTable(data: Request[] | undefined) {
  const tableData: TableData<Request>[] =
    data?.map((item) => {
      const urlToRedirect = getUrlRedirectByRequest(item)

      return {
        data: item,
        redirectURL: urlToRedirect
      }
    }) || []
  return createTableConfig<Request>(
    [
      { key: 'student.person.name', label: 'Nome do Estudante', hidden: false },
      {
        key: 'createdAt',
        label: 'Data da Abertura',
        toText: basicDataCellFormatter,
        hidden: false
      },
      {
        key: 'deadline',
        label: 'Prazo',
        hidden: false,
        getCustomStyle: getDeadlineColorByName
      },
      { key: 'student.ra', label: 'RA', hidden: false },
      {
        key: 'previousEducation.name',
        label: 'Curso Antigo',
        hidden: false
      },
      {
        key: 'desiredEducation.desiredEducation',
        label: 'Curso Desejado',
        hidden: false
      },
      {
        key: 'previousEducation.institution',
        label: 'IES Anterior',
        hidden: false
      },
      { key: 'requestStatus.name', label: 'Status', hidden: true }
    ],
    tableData
  )
}

export const useCreditTransfer = () => {
  const [searchParams] = useSearchParams()
  const queryParams = Object.fromEntries(searchParams.entries())
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: [QUERIES.QUERY_GET_REQUESTS_CREDIT_TRANSFER, queryParams],
    queryFn: () => {
      return getRequests({
        ...queryParams,
        requestType: REQUEST_TYPE.CREDIT_TRANSFER.id,
        status: REQUEST_STATUS.NOT_STARTED.id,
        orderBy: 'createdAt',
        orderType: ORDER_TYPE.ASC
      })
    },
    enabled: Object.keys(queryParams).length > 0
  })

  return {
    states: {
      data,
      isLoading,
      isError
    },
    actions: {
      refetch,
      createTable
    }
  }
}
